import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuSettings } from "react-icons/lu";

/**
 * EarningsSummary
 *
 * Props:
 * - earnings: { availableToPayout, ticketsSold }
 * - payouts: [{ payoutPeriod, amount, paidAt }]
 * - historyLoading: boolean
 */
export default function EarningsSummary({
  earnings,
  payouts = [],
  historyLoading = false,
}) {
  const navigate = useNavigate();

  function formatMoney(n) {
    return `$${Number(n || 0).toFixed(2)}`;
  }

  function previousMonthPeriod() {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  }

  function renderLastMonthNote() {
    if (historyLoading) return null;

    const prevPeriod = previousMonthPeriod();
    const lastPayout = payouts.find(
      (p) => p.payoutPeriod === prevPeriod
    );

    if (!lastPayout) {
      return (
        <div style={ui.payoutNoteMuted}>
          <strong>Last month’s payout:</strong> Not eligible
          <br />
          No earnings were available for payout
        </div>
      );
    }

    const paidDate = new Date(lastPayout.paidAt).toLocaleDateString(
      'en-US',
      { month: 'short', day: 'numeric' }
    );

    return (
      <div style={ui.payoutNote}>
        <strong>Last month’s payout:</strong>{' '}
        {formatMoney(lastPayout.amount)}
        <br />
        Released {paidDate} • Arrives in 1–2 business days via Stripe
      </div>
    );
  }

  const ticketsSold =
    typeof earnings?.ticketsSold === 'number' &&
    earnings.ticketsSold > 0
      ? earnings.ticketsSold
      : '—';

  return (
    <div style={ui.card}>
      <div style={ui.cardTitle}>Earnings Summary</div>

      {/* Available to payout */}
      <div style={ui.statRow}>
        <span>Available to payout</span>
        <strong>{formatMoney(earnings?.availableToPayout)}</strong>
      </div>
      <div style={ui.divider} />

      {/* Tickets sold */}
      <div style={ui.statRow}>
        <span>Tickets sold</span>
        <strong>{ticketsSold}</strong>
      </div>
      <div style={ui.divider} />

      {renderLastMonthNote()}

   <button
  style={{
    ...ui.payoutSettingsBtn,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  }}
  onClick={() => navigate('/host/payouts')}
>
  <LuSettings size={14} />
  Payout settings
</button>

    </div>
  );
}

/* ===============================
   STYLES
================================ */

const ui = {
  card: {
    borderRadius: 12,
    paddingTop: 12,
    paddingBottom: 8,
    marginBottom: 16,
    background: '#fff',
  },

  cardTitle: {
    fontSize: 13,
    fontWeight: 900,
    textTransform: 'uppercase',
    marginBottom: 8,
    color: '#555',
  },

  statRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 12,
    marginTop: 20,
        fontWeight: 700,

  },

divider: {
  height: 1,
  background: '#E5E7EB',

  marginTop: 12,     // space above the line
  marginBottom: 12,  // space below the line
},

  payoutNote: {
    marginTop: 10,
    fontSize: 12,
    color: '#374151',
    lineHeight: 1.4,
  },

  payoutNoteMuted: {
    marginTop: 10,
    fontSize: 12,
    color: '#6B7280',
    lineHeight: 1.4,
  },

  payoutSettingsBtn: {
    marginTop: 12,
    background: '#F3F4F6',
    border: '1px solid #E5E7EB',
    color: '#374151',
    fontSize: 12,
    fontWeight: 700,
    padding: '6px 10px',
    borderRadius: 8,
    cursor: 'pointer',
    width: 'fit-content',
  },
};
